<template>
    <!-- Shared with the embedded directory: search and result counts stay fixed around independently scrolling results. -->
    <BaseDialog
        v-model:open="isOpen"
        layout="custom"
        :title="t('connections.organizationDirectory.title')"
        :show-close="!isAdding"
        float-close
        :disable-close-on-backdrop-click="isAdding"
        :dialog-content-class="`md:w-140 flex flex-col transition-[height] duration-200 ease-in-out motion-reduce:transition-none ${isEmpty ? 'h-150' : 'h-full md:h-200'}`">
        <OrganizationProfileDirectoryContent
            v-bind="props"
            @added="emit('added')"
            @removed="emit('removed')"
            @close="isOpen = false"
            @busy="isAdding = $event"
            @empty="isEmpty = $event" />
    </BaseDialog>
</template>

<script setup lang="ts">
import type { ProfileDirectorySource } from "~vue/api/generated/collab-profiles";
import BaseDialog from "~vue/components/BaseDialog.vue";
import OrganizationProfileDirectoryContent from "~vue/Connections/OrganizationProfileDirectoryContent.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps<{ hasCollaborationProfile: boolean; createProfileUrl: string; inviteUrl: string; source: ProfileDirectorySource }>();
const isOpen = defineModel<boolean>("open", { default: false });
const emit = defineEmits<{ added: []; removed: [] }>();
const isAdding = ref(false);
const isEmpty = ref(false);
</script>
